export enum HANDLE_RESULTS {
  DEFAULT,
  REDIRECT,
  DISPLAY_TABLE,
}

export interface ISearchTerms {
  identityId?: string;
  email?: string;
  firstName?: string;
  lastName?: string;
  entitlementSourceId?: string;
}

export interface IEntitlementId {
  process: string;
  system: string;
  sourceId: string;
}

export interface IEntitlementInfo {
  id: IEntitlementId;
  importedBy: string;
  claims: any[];
  roles?: string[];
  modificationTimeStamp: string;
}

export interface ISearchResult {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  entitlements: IEntitlementInfo[];
}

export interface IPagedResult<T> {
  pageSize: number;
  pageNumber: number;
  total: number;
  data: T;
}

export interface IKeysetPaginationResult<T> {
  items: readonly T[];
  totalCount: number;
  pageSize: number;
  hasPrevious: boolean;
  hasNext: boolean;
}
